import React from 'react';
import {Affix } from "antd";
import {
    imgUrlSite,
    getCookie,
    delCookie,
    setSessionItem,
    delSessionItem,
} from '../../common/service/common.js';
export default class checkHeader extends React.Component {
    state={
        userInfo:{},
        phone:'',
        verifyCode:'',
        tips:'',
        tipsType:'error',
        phoneCheckStatus:false,
        hasSend:false,
        getDisabled:false,
        registerStatus:false,
        weChatCodeFlag:false,
        getSid:'',
        userinfoFlag:false,
        registerFlag:false,
    }
    getCheckLogin(e){
        e.nativeEvent.stopImmediatePropagation();
        this.props.onLogin(true)
    }
    logout=()=>{
        this.setState({userInfo:{}});
        delCookie('z_sid');
        delSessionItem('userInfo');//缓存用户的登录信息
        delSessionItem('checkStep');//专家完善信息的选择身份信息
        window.location.href='/checkpaper.html';//退出返回首页
    }
    
    componentDidMount() {
        var sid = getCookie("z_sid");
        if(sid) {
            React.$http.getUserInfo().then((res)=>{
                if(res&&res.success){
                    if(res.userInfo){
                        this.setState({
                            userInfo: res.userInfo,
                        });
                        setSessionItem('userInfo',res.userInfo);                        
                    }
                }else{
                    return;
                }
            });
            /*var userId = getCookie('userId')?getCookie('userId'):'';
            if(userId!==''){
                React.$http.personInfo({
                    userId:userId
                }).then((res)=>{
                    if(res&&res.success){
                        if(res.userInfo){
                            this.setState({
                                userInfo: res.userInfo,
                            });
                            setSessionItem('userInfo',res.userInfo);                        
                        }
                    }else{
                        return;
                    }
                });
            }*/
        }   
    }
    render() {
        const {
            userInfo
        } = this.state;
        return (
            <div className="headerWrap">
                <Affix>
                    <div className="headfix">
                        <div className="header">
                            {/* <div className="logo">
                                <a href="/">
                                    <img src="/assets/images/logo.png" alt=""/>
                                </a>
                            </div> */}
                            <div className="titlenav">
                                {/* <span className="spo"></span> */}
                                <a className="deblock" href="/checkpaper.html#/index">论文查重</a>
                            </div>
                            {
                                userInfo.userId?(
                                    <div className="userInfo">
                                        <a className="deblock" href="/checkpaper.html#/order">我的查重</a>
                                        <span className="uispo"></span>
                                        <div className="userHead">
                                            <div className="unames">
                                                <img src={userInfo.imgUrl?imgUrlSite+userInfo.imgUrl:'/assets/images/head1.png'} style={{height:'38px'}} alt="头像" />
                                            </div>
                                            <div className="list">
                                                {/* <div>
                                                    <a href="/wallet.html#/" target="_blank">我的钱包</a>
                                                </div> */}
                                                <div onClick={this.logout}>退出登录</div>
                                            </div>
                                        </div>
                                    </div>
                                ):(
                                    <div className="userInfo">
                                        <span className="login" onClick={(e)=>this.getCheckLogin(e)}>登录</span>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </Affix>
            </div>
        );
    }
}